import React from 'react';
import './Maintenance.css';
import { FaTwitch, FaInstagram, FaDiscord, FaTiktok } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { IoConstruct } from 'react-icons/io5';

const SOCIALS = [
  { id: 'twitch', label: 'Twitch', url: 'https://twitch.tv/jizonn', Icon: FaTwitch },
  { id: 'instagram', label: 'Instagram', url: 'https://www.instagram.com/noeliatwentyone/', Icon: FaInstagram },
  { id: 'discord', label: 'Discord', url: 'https://discord.gg/Bn4KryKjJ8', Icon: FaDiscord },
  { id: 'twitter', label: 'X', url: 'https://x.com/j1zoNN', Icon: FaXTwitter },
  { id: 'tiktok', label: 'TikTok', url: 'https://www.tiktok.com/@noeliatwentyone', Icon: FaTiktok },
];

function Maintenance() {
  return (
    <div className="maintenance-container">
      <div className="maintenance-content">
        <div className="maintenance-icon">
          <IoConstruct />
        </div>
        <h1 className="maintenance-title">Em Manutenção</h1>
        <p className="maintenance-subtext">
          Volta em breve!
        </p>
        <div className="maintenance-social">
          {SOCIALS.map((s) => (
            <a
              key={s.id}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`maintenance-link ${s.id}`}
              aria-label={s.label}
              title={s.label}
            >
              <s.Icon />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Maintenance;
